import JohnK from "./assets/boardmembers/John-Kocjan.jpg";

import SarahJ from "./assets/boardmembers/Sarah-Jamieson.jpg";

import BillD from "./assets/boardmembers/Bill Headshot.png";

import DavidB from "./assets/boardmembers/David-Bremner.jpg";

import PeterF from "./assets/boardmembers/Peter-Ferrante.jpg";

import IanH from "./assets/boardmembers/Ian-Henderson.jpg";

import NorineJ from "./assets/boardmembers/Norine-Jones.jpg";

import GlennS from "./assets/boardmembers/Glenn-Smith.jpg";

import MartinL from "./assets/boardmembers/Martin-Ling.jpg";

import CatherineM from "./assets/boardmembers/Catherine-Mills.jpg";

import SteveK from "./assets/boardmembers/steve.png";

import BruceDecker from "./assets/boardmembers/BruceDecker.jpg";

import MHarrett from "./assets/boardmembers/Harrett headshot.jpg";

import SteveF from "./assets/boardmembers/Steve Headshot.jpg";

const boardMembers = [
  {
    title: "President",
    name: "Peter Ferrante",
    company: "Ferro Canada Inc.",
    address: "955 Alliance Rd., Unit 2, Pickering, ON L1W 3M8",
    phone: "905-841-8108",
    fax: "905-841-7174",
    email: "peter@ferrocanada.com",
    image: PeterF,
  },
  {
    title: "Vice President",
    name: "Sarah Jamieson",
    company: "EMSL Canada, Inc.",
    address: "2756 Slough Street, Mississauga, ON L4T 1G3",
    phone: "289-997-4602",
    fax: "289-997-4607",
    email: "sjamieson@emsl.com",
    image: SarahJ,
  },

  {
    title: "Past President",
    name: "John Kocjan",
    company: "ECOH Management Inc.",
    address: "75 Courtneypark Drive West, Unit 1, Mississauga, ON, L5W 0E3",
    phone: "905-795-2800 ",
    fax: "905-795-2870",
    email: " jkocjan@ecoh.ca",
    image: JohnK,
  },
  {
    title: "Treasurer",
    name: "David Bremner",
    company: "Environmental Response Team (ERT)",
    address: "2850 Lakeshore Blvd W, Etobicoke, Ontario M8V 4A1",
    phone: "416 -255-6745",
    fax: "416-255-6485",
    email: "davidbremner@erthazmat.com",
    image: DavidB,
  },
  {
    title: "Executive Director",
    name: "Steve Fulford",
    company: "Fulford Roy and Associates Consulting Inc.",
    address: "292 Wright Ave, Toronto, Ontario M6R 1L9",
    phone: "647-850-7878",
    fax: "",
    email: "sfulford@eaccan.com",
    image: SteveF,
  },

  {
    title: "Directors At Large",
    name: "Bill Donnelly",
    company: "DEWAR",
    address: "201 - 1143 Wentworth St West, Oshawa, ON, Canada L1J 8P7",
    phone: "905-409-6286",
    email: "bill.donnelly@dewar.ca",
    image: BillD,
  },

  {
    name: "Bruce Decker",
    company: "ECOH Management Inc.",
    address: "75 Courtneypark Drive West, Unit 1, Mississauga, ON L5W 0E3",
    phone: "416-371-4845",
    email: "bdecker@ecoh.ca",
    image: BruceDecker,
  },
  {
    name: "Mike Harrett",
    company: "Pinchin Ltd.",
    address: "1456 Centennial Drive, Kingston, ON K7P 0C7",
    phone: "613-484-3370",
    email: "mharrett@Pinchin.com",
    image: MHarrett,
  },
  {
    name: "Ian Henderson",
    company: "H&S Specialties Inc.",
    address: "1060 Salk Rd. Unit 5, Pickering, ON L1W 3C5",
    phone: "416-556-5893",
    email: "ihenderson@hsspecialties.com",
    image: IanH,
  },
  {
    name: "Norine Jones",
    company: "Power Vac Services and Power Environmental Management",
    address: "321 Anchor Rd. #2, Hamilton, ON L8W 3R1",
    phone: "905-318-0622",
    fax: "",
    email: "njones@powervachamilton.ca",
    image: NorineJ,
  },

  {
    name: "Martin Ling",
    company: "Stantec",
    address: "300-125 Commerce Valley Drive West, Markham, ON  L3T 7W4",
    phone: "905-415-6386",
    fax: "905-474-9889",
    email: "martin.ling@stantec.com",
    image: MartinL,
  },
  {
    name: "Catherine Mills",
    company: "ECOH Management Inc.",
    address: "75 Courtneypark Drive West, Unit 1, Mississauga, ON L5W 0E3",
    phone: "416-640-2444",
    email: "cmills@ecoh.ca",
    image: CatherineM,
  },
  {
    name: "Glenn Smith",
    company: "Safetech Environmental Ltd.",
    address: "3045 Southcreek Road, Unit #14, Mississauga, ON L4X 2X7",
    phone: "905-624-2722",
    fax: "905-624-4306",
    email: "gsmith@safetechenv.com",
    image: GlennS,
  },
  {
    name: "Steve Kerr",
    company: "JMX Environmental Inc.",
    address: "1958 Notion Road, Pickering, ON L1V 2G3",
    phone: "905-426-8315",
    email: " steve.kerr@jmxenv.com",
    image: SteveK,
  },
];

export default boardMembers;
